import React, { Component } from 'react';
import PropTypes from 'prop-types';

import history from '../../history';

export default function withFilters(WrappedComponent) {
  class FilterWrapper extends Component {
    constructor(props) {
      super(props);
      this.state = { filters: new Map([...this.props.filters]) };
      this.handleEventChange = this.handleEventChange.bind(this);
      this.handleValueChange = this.handleValueChange.bind(this);
      this.handleSubmit = this.handleSubmit.bind(this);
      this.handleClear = this.handleClear.bind(this);
    }

    setSort(sort) {
      const { onSortSubmit } = this.props;
      onSortSubmit(sort.split(':'));
    }

    handleEventChange(event) {
      if (event.target.value === 'reset' || event.target.value === '') {
        this.state.filters.delete(event.target.name);
        this.setState({ filters: new Map([...this.state.filters]) });
      } else {
        const value = event.target.type === 'number'
          ? parseFloat(event.target.value, 10)
          : event.target.value;
        const filters = new Map([...this.state.filters, [event.target.name, value]]);
        this.setState({
          filters,
        });
      }
    }

    handleValueChange(name, value) {
      this.setState({ filters: new Map([...this.state.filters, [name, value]]) });
    }

    handleClear(name) {
      this.state.filters.delete(name);
      this.setState({ filters: new Map([...this.state.filters]) });
    }

    handleSubmit(e, shouldClose = true) {
      const { location, onSubmitClick, onCloseClick, propertyType } = this.props;
      e.preventDefault();
      const current = location && location.pathname.split('/')[1];
      if (shouldClose) {
        onCloseClick();
      }
      onSubmitClick(this.state.filters);
      if (location && propertyType && current !== propertyType) {
        if (location.search && location.search.indexOf('?organization=') === 0) {
          history.push(`/${propertyType}${location.search}`);
        } else {
          history.push(`/${propertyType}`);
        }
      }
    }

    render() {
      return (<WrappedComponent
        {...this.props}
        filters={this.state.filters}
        handleSubmit={this.handleSubmit}
        handleEventChange={this.handleEventChange}
        handleValueChange={this.handleValueChange}
        handleClear={this.handleClear}
      />);
    }
  }

  FilterWrapper.propTypes = {
    filters: PropTypes.object,
    location: PropTypes.object,
    onSortSubmit: PropTypes.func,
    onSubmitClick: PropTypes.func,
    onCloseClick: PropTypes.func,
    propertyType: PropTypes.string,
  };

  return FilterWrapper;
}



// WEBPACK FOOTER //
// ./src/components/Filter/WithFilters.js